









import { Component, Vue } from 'vue-property-decorator'
import ImageUploader from '@/components/account/ImageUploader.vue'

@Component({ name: 'AvatarForm',
  components: {
    ImageUploader
  }
})
export default class AvatarForm extends Vue {
}
